/* eslint-disable max-len */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable import-helpers/order-imports */
/* eslint-disable no-shadow */

import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  Row,
} from 'reactstrap';

import { yupResolver } from '@hookform/resolvers/yup';

import CustomSelectSearch from '../../components/CustomSelectSearch';
import { buildReembolsoFormData, validateClienteNicash } from '../../components/NicashReembolso/buildReembolsoFormData';
import {
  applyNicClienteAutoFill,
  mapUsersToClientesOptions,
} from '../../components/NicashReembolso/clientesReembolso';
import ReembolsoFormFields from '../../components/NicashReembolso/ReembolsoFormFields';
import { defaultFormValues, schema } from '../../components/NicashReembolso/validationSchema';
import { AppContext } from '../../contexts/app';
import api from '../../services/api';

function NicashReembolsoCadastrar() {
  const navigate = useNavigate();
  const { loading, setLoading, notificationRef } = useContext(AppContext);
  const [profissionais, setProfissionais] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [loadingClientes, setLoadingClientes] = useState(false);

  const {
    control,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...defaultFormValues,
      profissional: '',
    },
    resolver: yupResolver(schema),
  });

  const responsavelTipo = watch('responsavelTipo');
  const formaPagamento = watch('formaPagamento');

  useEffect(() => {
    (async () => {
      try {
        const { data = [] } = await api.get('/profissionais?limit=0');
        setProfissionais(data.map((d) => ({
          value: d._id,
          label: d.name,
        })));
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  useEffect(() => {
    if (responsavelTipo === 'paciente') {
      setValue('cliente', '');
      clearErrors('cliente');
    }
  }, [clearErrors, responsavelTipo, setValue]);

  useEffect(() => {
    if (formaPagamento === 'reembolso') {
      setValue('ultimosNumerosCartao', '');
    }
  }, [formaPagamento, setValue]);

  useEffect(() => {
    const needsClientes = responsavelTipo === 'paciente'
      || responsavelTipo === 'nic_sp'
      || responsavelTipo === 'nic_go';

    if (!needsClientes) {
      setClientes([]);
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        setLoadingClientes(true);
        const { data = [] } = await api.get('/users?limit=0');
        if (cancelled) return;
        const clientesMapeados = mapUsersToClientesOptions(data);
        setClientes(clientesMapeados);

        if (responsavelTipo === 'nic_sp' || responsavelTipo === 'nic_go') {
          applyNicClienteAutoFill({
            responsavelTipo,
            clientes: clientesMapeados,
            setValue,
            setError,
            clearErrors,
            notificationRef,
          });
        }
      } catch (error) {
        if (!cancelled) {
          console.error(error);
          if (responsavelTipo === 'nic_sp' || responsavelTipo === 'nic_go') {
            setValue('cliente', '');
            setError('cliente', {
              type: 'manual',
              message: 'Não foi encontrado cliente para o responsável escolhido',
            });
            notificationRef.current.notify({
              message: 'Não foi encontrado cliente para o responsável escolhido',
              color: 'warning',
            });
          }
        }
      } finally {
        if (!cancelled) {
          setLoadingClientes(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [clearErrors, notificationRef, responsavelTipo, setError, setValue]);

  const onSubmit = useCallback((formValues) => {
    const { profissional, ...reembolsoValues } = formValues;
    const profissionalId = profissional?.value || profissional;

    if (!profissionalId) {
      setError('profissional', { type: 'manual', message: 'Selecione um profissional' });
      return;
    }

    if (!validateClienteNicash(reembolsoValues, setError)) {
      return;
    }

    (async () => {
      try {
        setLoading({ loading: true, message: 'Cadastrando reembolso...' });
        const formData = buildReembolsoFormData(reembolsoValues);
        await api.post(
          `/financeiroProfissionalReembolsos?profissionalId=${profissionalId}`,
          formData,
        );
        setLoading(false);
        notificationRef.current.notify({ message: 'Solicitação de reembolso realizada com sucesso' });
        navigate('/nicash-reembolsos');
      } catch (error) {
        setLoading(false);
        notificationRef.current.notify({
          message: error?.response?.data?.message || 'Falha ao cadastrar reembolso',
          color: 'danger',
        });
      }
    })();
  }, [navigate, notificationRef, setError, setLoading]);

  return (
    <Container fluid>
      <Row className="mt-5">
        <Col>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <h3>Cadastrar Reembolso</h3>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <Controller
                      name="profissional"
                      control={control}
                      render={({ field: { onChange, name, value } }) => (
                        <FormGroup>
                          <Label for="profissionalSelectReembolso">
                            Profissional (*)
                          </Label>
                          <CustomSelectSearch
                            id="profissionalSelectReembolso"
                            name={name}
                            value={value}
                            onChange={onChange}
                            options={profissionais}
                            placeholder="Selecione um Profissional"
                            invalid={!!errors?.profissional?.message}
                            errorMessage={errors?.profissional?.message}
                            loadingMessage="Carregando profissionais"
                            noOptionsMessage="Nenhum profissional encontrado"
                          />
                        </FormGroup>
                      )}
                    />
                  </Col>
                </Row>
                <ReembolsoFormFields
                  control={control}
                  errors={errors}
                  responsavelTipo={responsavelTipo}
                  formaPagamento={formaPagamento}
                  clientes={clientes}
                  loadingClientes={loadingClientes}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col xs={12} sm={6}>
            <Button type="submit" color="success" disabled={loading} block>
              Cadastrar
            </Button>
          </Col>
          <Col xs={12} sm={6}>
            <Button
              color="danger"
              disabled={loading}
              onClick={() => navigate('/nicash-reembolsos')}
              block
            >
              Cancelar
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}

export default NicashReembolsoCadastrar;
